import { position } from './../../../models/position';
import { RentalDeliveryTypeEnum } from './../../../models/enums/BookingEnums';
import { CustomerSummaryModel } from 'src/app/models/Profile/CustomerSummaryModel';
import { ResourceService } from 'src/app/services/resource.service';
import { PayModalComponent } from './../pay-modal/pay-modal.component';
import { SelectedVehicleService } from './../../../services/selectedVehicle.service';
import { AccountStatmentModel } from './../../../models/Payments/AccountStatmentModel';
import { PaymentModel } from './../../../models/Booking/PaymentModel';
import { LoadingService } from './../../../services/loading.service';
import { Router } from '@angular/router';
import { Customer } from './../../../models/Customer';
import { AuthService } from './../../../services/auth.service';
import { DriverSkillModel } from './../../../models/Booking/DriverSkillModel';
import { Component, OnInit, ChangeDetectorRef, ViewChild, OnDestroy } from '@angular/core';
import { SearchService } from 'src/app/services/search.service';
import { BookingService } from './../../../services/booking.service';
import { faRoad, faBusinessTime, faCalendarAlt, faClipboard, faDollarSign, faListAlt, faMapMarkerAlt, faPlusCircle, faCar, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { faBatteryHalf } from '@fortawesome/free-solid-svg-icons';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { GoogleMapPinComponent } from 'src/app/views/booking/google-map-pin/google-map-pin.component';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ViewBookingModel } from 'src/app/models/Booking/ViewBookingModel';
import { AdditionalServiceType, AgeRestrictionPolicyTypes, AllowedReplacementTypeID, AmountPolicyTypes, AppliedChargingRate, AppliedChargingRateOnExtendedPeriod, AppliedRateTypeID, CancelationPolicyChargeTypes, DepositPolicyPaymentTypes, ExceededDistancePolicyTypes, ExtensionRules, FuelChargingPolicyTypes, PolicyType, PredefinedAdditionalServiceEnum, RentalContractTerminationPeriodTypes, SecurityDepositType } from 'src/app/models/enums/BookingEnums';
import { LstAdditionalServiceReservationCase } from 'src/app/models/VehicleReservationCaseDetailsModel';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { AttachmentScopesEnum, AttachmentTypeEnum } from 'src/app/models/enums/Attachment/AttachmentEnum';
import { AttachmentService } from 'src/app/services/attachment.service';
import { IconService } from './../../../services/icon.service';
import { Subscription } from 'rxjs';
import { Vehicle } from 'src/app/models/Vehicle';
import { EventEmitter, Output } from '@angular/core';
import { CmsService } from './../../../services/cms.service';


@Component({
  selector: 'view-booking-details',
  templateUrl: './view-booking-details.component.html',
  styleUrls: ['./view-booking-details.component.css']
})


export class ViewBookingDetailsComponent implements OnInit, OnDestroy {




  clickPay = false;

  math = Math;
  paymentModel: PaymentModel[];
  paymentTabIndex = 2;
  policies;
  reviews;
  reviewComments;
  TermsAndCondition;
  currency;
  faBatteryHalf = faBatteryHalf;
  faMapMarkerAlt = faMapMarkerAlt;
  faPlusCircle = faPlusCircle;
  faTimesCircle = faTimesCircle;
  faDollarSign = faDollarSign;
  faClipboard = faClipboard;
  faCar = faCar;
  faRoad = faRoad;
  faBusinessTime = faBusinessTime;
  faListAlt = faListAlt;
  faCalendarAlt = faCalendarAlt;
  viewBooking: ViewBookingModel;
  driverSkills: DriverSkillModel[] = [];
  customer: Customer;
  customerSummary: CustomerSummaryModel;
  policyTypeResourcePrefix = 'policyType_';
  accountStatment: AccountStatmentModel;
  subscriptions: Subscription[] = [];
  vehicle: Vehicle;
  logo;
  isPrinting = false;
  recivedPaymentModel: PaymentModel[];
  tabIndedx: any;

  constructor(private authService: AuthService
    , private dialog: MatDialog
    , private matIconRegistry: MatIconRegistry
    , private domSanitizer: DomSanitizer
    , private bookingService: BookingService
    , private searchService: SearchService
    , private router: Router
    , private cd: ChangeDetectorRef
    , private loadingService: LoadingService
    , private attachmentService: AttachmentService
    , private iconService: IconService
    , private selectedVehicleService: SelectedVehicleService
    , private cmsService: CmsService
    , private resourceService: ResourceService
  ) {

    this.matIconRegistry.addSvgIcon(
      "steeringWheel",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.steeringWheel)
    );
    this.matIconRegistry.addSvgIcon(
      "childSeats",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.childSeats)
    );
    this.matIconRegistry.addSvgIcon(
      "GPSNavigation",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.GPSNavigation)
    );
    this.matIconRegistry.addSvgIcon(
      "additionalService",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.additionalService)
    );

    // this.matIconRegistry.addSvgIcon(
    //   "lateReturn",
    //   this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.lateReturn)
    // );
    // this.matIconRegistry.addSvgIcon(
    //   "rentalContractExtension",
    //   this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.rentalContractExtension)
    // );
    // this.matIconRegistry.addSvgIcon(
    //   "rentalContractTermination",
    //   this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.rentalContractTermination)
    // );
    // this.matIconRegistry.addSvgIcon(
    //   "rentalReplacement",
    //   this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.rentalReplacement)
    // );



    this.currency = searchService.getCurrency();

    this.TermsAndCondition = bookingService.getTermsAndCondition('');
  }



  ngOnDestroy(): void {
    this.subscriptions.forEach(item => {
      item.unsubscribe();
    })
  }

  ngOnInit() {
    /* setTimeout(() => {
      this.loadingService.updateLoadingState(true);
    }); */
    this.subscriptions.push(this.bookingService.viewBookingModel.subscribe(res => {

      this.viewBooking = res;

      this.subscriptions.push(this.bookingService.getDriverSkills().subscribe(res => {

        this.driverSkills = res.filter(o => this.viewBooking.selectedSkillIds.includes(o.driverSkillID + ""));
        this.bookingService.updateDriverSkills(this.driverSkills);
        /*  this.loadingService.updateLoadingState(false); */
      }))
    }));
    this.subscriptions.push(this.authService.loggedInCustomer.subscribe(res => {
      if(res!=null){
        this.customer = res;
        this.getLatestCustomerSummary(this.customer.customerID);

      }

    }));
    this.subscriptions.push(this.selectedVehicleService.vehicle.subscribe(res => {
      this.vehicle = res;
    }))

    this.cmsService.contentModel.subscribe(theme => {

      if (theme != null) {
        ;
        // this.myTheme = theme.theme;
        this.logo = theme.theme.logo;
      }
    });




  }
  getLatestCustomerSummary(customerID: string) {
    this.authService.getCustomerSummary(customerID).subscribe(res => {
      this.customerSummary = res;
    })
  }

  printClicked(payment: PaymentModel) {
    this.recivedPayment(payment);

  }


  openPickUpMap() {


    var service = this.lstAdditionalServiceReservationCase.filter(a => a.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.RentalDelivery)[0];
    var rentalPickUp = service.lstVehicleReservationCaseAdditionalServicesRentalDeliveryModel.filter(a => a.rentalDeliveryTypeID == RentalDeliveryTypeEnum.Delivery)[0];


    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      isDraggable: false,
      position: {
        latitude: rentalPickUp.latitude,
        longitude: rentalPickUp.longitude,
        address: this.viewBooking.pickupAddress
      }
    }
    this.dialog.open(GoogleMapPinComponent, dialogConfig);
  }


  openDropOffMap() {
    var service = this.lstAdditionalServiceReservationCase.filter(a => a.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.RentalDelivery)[0];
    var rentalDropOff = service.lstVehicleReservationCaseAdditionalServicesRentalDeliveryModel.filter(a => a.rentalDeliveryTypeID == RentalDeliveryTypeEnum.Receive)[0];


    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      isDraggable: false,
      position: {
        latitude: rentalDropOff.latitude,
        longitude: rentalDropOff.longitude,
        address: this.viewBooking.returnAddress
      }
    }
    this.dialog.open(GoogleMapPinComponent, dialogConfig);
  }


  openMapDialog(type) {
    var service = this.lstAdditionalServiceReservationCase.filter(a => a.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.RentalDelivery)[0];


    let position = null;

    if (type == 1) {
      var rentalPickUp = service.lstVehicleReservationCaseAdditionalServicesRentalDeliveryModel.filter(a => a.rentalDeliveryTypeID == RentalDeliveryTypeEnum.Delivery)[0];
      position = {
        latitude: rentalPickUp.latitude,
        longitude: rentalPickUp.longitude,
        address: this.viewBooking.pickupAddress
      }
    }
    else if (type == 2) {
      var rentalDropOff = service.lstVehicleReservationCaseAdditionalServicesRentalDeliveryModel.filter(a => a.rentalDeliveryTypeID == RentalDeliveryTypeEnum.Receive)[0];
      position = {
        latitude: rentalDropOff.latitude,
        longitude: rentalDropOff.longitude,
        address: this.viewBooking.returnAddress
      };
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      isDraggable: false,
      position: position
    }
    this.dialog.open(GoogleMapPinComponent, dialogConfig);
  }




  @ViewChild(MatTable) table: MatTable<any>;

  get lstAdditionalServiceReservationCase(): LstAdditionalServiceReservationCase[] {
    if (this.viewBooking != null && this.viewBooking.lstAdditionalServiceReservationCase != null) {

      return this.viewBooking.lstAdditionalServiceReservationCase;
    }
    else {
      return [];
    }

  }

  get lstAdditionalServiceReservationCaseTypeService(): LstAdditionalServiceReservationCase[] {
    if (this.viewBooking != null && this.viewBooking.lstAdditionalServiceReservationCase != null) {

      return this.viewBooking.lstAdditionalServiceReservationCase.filter(a => a.additionalServiceTypeID == AdditionalServiceType.Service);
    }
    else {
      return [];
    }

  }

  get lstAdditionalServiceReservationCaseTypeCharge(): LstAdditionalServiceReservationCase[] {
    if (this.viewBooking != null && this.viewBooking.lstAdditionalServiceReservationCase != null) {
      return this.viewBooking.lstAdditionalServiceReservationCase.filter(a => a.additionalServiceTypeID == AdditionalServiceType.Charge);;
    }
    else {
      return [];
    }

  }
  public get predefinedAdditionalServiceEnum(): typeof PredefinedAdditionalServiceEnum {
    return PredefinedAdditionalServiceEnum;
  }
  get attachmentScopesEnum() {
    return AttachmentScopesEnum;
  }
  get attachmentTypeEnum() {
    return AttachmentTypeEnum;
  }
  //#region  Policies Enum


  public get additionalServiceType(): typeof AdditionalServiceType {
    return AdditionalServiceType;
  }

  public get policyType(): typeof PolicyType {
    return PolicyType;
  }
  public get depositPolicyPaymentTypes(): typeof DepositPolicyPaymentTypes {
    return DepositPolicyPaymentTypes;
  }
  public get appliedChargingRate(): typeof AppliedChargingRate {
    return AppliedChargingRate;
  }
  public get cancelationPolicyChargeTypes(): typeof CancelationPolicyChargeTypes {
    return CancelationPolicyChargeTypes;
  }
  public get allowedReplacementTypeID(): typeof AllowedReplacementTypeID {
    return AllowedReplacementTypeID;
  }
  public get fuelChargingPolicyTypes(): typeof FuelChargingPolicyTypes {
    return FuelChargingPolicyTypes;
  }

  public get rentalContractTerminationPeriodTypes(): typeof RentalContractTerminationPeriodTypes {
    return RentalContractTerminationPeriodTypes;
  }

  public get exceededDistancePolicyTypes(): typeof ExceededDistancePolicyTypes {
    return ExceededDistancePolicyTypes;
  }

  public get extensionRules(): typeof ExtensionRules {
    return ExtensionRules;
  }
  public get appliedChargingRateOnExtendedPeriod(): typeof AppliedChargingRateOnExtendedPeriod {
    return AppliedChargingRateOnExtendedPeriod;
  }

  public get ageRestrictionPolicyTypes(): typeof AgeRestrictionPolicyTypes {
    return AgeRestrictionPolicyTypes;
  }
  public get amountPolicyTypes(): typeof AmountPolicyTypes {
    return AmountPolicyTypes;
  }

  public get appliedRateTypeID(): typeof AppliedRateTypeID {
    return AppliedRateTypeID;
  }

  public get securityDepositType(): typeof SecurityDepositType {
    return SecurityDepositType;
  }
  //#endregion

  /* Table */
  displayedColumns = ['ReceiptNo', 'Date', 'Method', 'Amount'];
  dataSource = new MatTableDataSource<Element>(ELEMENT_DATA);




  onTabClick(event) {


    const tab = event.tab.textLabel;

    this.tabIndedx = event.index;
    //IF Payment Tab
    if (event.index === 2) {
      //Reset the view to show the updated (latest) balance
      this.clickPay = false;
      this.bookingService.getPayments(this.customer.customerID, this.viewBooking.caseID)
        .subscribe(res => {

          // this.loadingService.updateLoadingState(false);
          this.paymentModel = res;
          //this.table.renderRows();

        });
      this.bookingService.getAccountStatment(this.customer.customerID
        , this.viewBooking.agencyID
        , this.viewBooking.caseID, this.viewBooking.startDateString
        , this.viewBooking.endDateString
      ).subscribe(res => {
        this.accountStatment = res;
      })

    }
    else if (event.index == 1) {

      this.getLatestCustomerSummary(this.customer.customerID);

    }


  }

  tabChanged(tabChangeEvent: MatTabChangeEvent) {
    //Todo:check if payment tab



  }



  recivedPayment(payment: PaymentModel) {
    this.bookingService.getReceivedPayment(payment.paymentID, payment.paymentGatewayID)
      .subscribe(res => {
        //
        this.recivedPaymentModel = res;
        this.isPrinting = true;
        setTimeout(() => {
          window.print();
          this.isPrinting = false;
        }, 350);

      });

  }

  openPayModal() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      viewBooking: this.viewBooking
    }
    // this.dialog.open(PayModalComponent, dialogConfig);

    this.clickPay = true;

  }

  changeViewType() {

    this.resourceService.updatePaymentFlag(false);
    this.clickPay = false;
  }


  loadAdditionalServiceIcon(additionalService: LstAdditionalServiceReservationCase) {
    if (additionalService.iconUrl == null) {

      this.attachmentService.imageHandler(additionalService.additionalServiceID, AttachmentScopesEnum.Setting, AttachmentTypeEnum.AdditionalServicesIcon).subscribe(res => {

        //let sanitizedUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(res)
        additionalService.iconUrl = res + '';
        this.cd.markForCheck();
      })
    }
    return additionalService.iconUrl;
  }


}



export interface Element {
  ReceiptNo: string;
  Date: string;
  Method: string;
  Amount: number;
}

const ELEMENT_DATA: Element[] = [
  { ReceiptNo: 'R#125487', Date: '2-2-2015', Method: '10:00', Amount: 1.0079 },
  { ReceiptNo: 'R#111487', Date: '2-2-2015', Method: '10:00', Amount: 1.0079 },
  { ReceiptNo: 'R#122484', Date: '2-2-2015', Method: '10:00', Amount: 1.0079 },
];


